import { Component } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { map, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ApiService } from 'src/services/apiService';
import { SweetAlertService } from 'src/services/sweetAlertService';

@Component({
  selector: 'app-add-exemption-book',
  templateUrl: './add-exemption-book.component.html',
  styleUrl: './add-exemption-book.component.css'
})
export class AddExemptionBookComponent {

  exemptionForm!: FormGroup;
  filePath: string | undefined;

  constructor(private fb: FormBuilder, private apiService: ApiService,private sweetAlertService:SweetAlertService) {}

  ngOnInit(): void {
    this.exemptionForm = this.fb.group({
      bookNumber: ['', Validators.required],
      taxNumber: ['', Validators.required],
      expireDate: ['', Validators.required],
      file: [null, Validators.required]
    });
  }

  onUploadFile(event: any): void {
    const file = event.target.files[0];
    if (file) {
      this.uploadFileAndGetObjectName(file).subscribe(response => {
        this.filePath = response;
        this.exemptionForm.get('file')?.setValue(this.filePath);
      });
    }
  }

  uploadFileAndGetObjectName(file: any): Observable<string> {

    const newGuid = this.generateGUID();

    return this.apiService.uploadFile(file, newGuid).pipe(
      map((response: any) => response.data.path)
    );
  }

  generateGUID(): string {

    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      const r = Math.random() * 16 | 0;
      const v = c === 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }


  addExemptionBook(): void {
    if (this.exemptionForm.invalid || !this.filePath) {
      this.exemptionForm.markAllAsTouched();
      return;
    }

    const formValue = this.exemptionForm.value;

    const body = {
      bookNumber: formValue.bookNumber,
      taxNumber: formValue.taxNumber,
      expireDate: formValue.expireDate,
      filePath: this.filePath
    };

    this.apiService.post('Customs/AddOrUpdateExemptionBook', body,environment.getterLink).subscribe(response => {
      if(response.value==true){
        this.sweetAlertService.ShowAlertThenRedirect('success','تم الحفظ بنجاح',"/Investment/ControlPanel/add-exemption-book");
      }
      console.log('Saved successfully', response);
    });
  }

}
